import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function ProofSection() {
  return <section className="py-20 px-4" data-id="element-184">
      <div className="max-w-4xl mx-auto" data-id="element-185">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-gradient-to-br from-emerald-900/20 to-blue-900/20 border border-emerald-500/30 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-186">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-[radial-gradient(ellipse_at_top,rgba(16,185,129,0.15),transparent_50%)] pointer-events-none" data-id="element-187" />

          <ShieldCheck className="w-16 h-16 text-emerald-400 mx-auto mb-6" data-id="element-188" />

          <p className="text-xl md:text-2xl text-white leading-relaxed font-medium relative z-10" data-id="element-189">
            En los próximos 7 días, podrías estar enviando tu primera factura en
            dólares. No necesitás ser un genio. El mundo es grande y hay
            millones de personas dispuestas a pagar por velocidad. Vos vas a ser
            quien les provea esa velocidad usando IA.{' '}
            <span className="text-emerald-400 font-bold" data-id="element-190">
              Mientras otros se quejan de la suba del dólar, vos vas a empezar a
              sonreír cuando suba.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}